import { Button } from '@/components/ui/button';
import { ServiceModal } from '@/components/ServiceModal';
import { CreditCard } from 'lucide-react';

interface VehicleDetailFinancingProps {
  vehicle: any;
  config: any;
  primaryColor: string;
  financingService: any;
}

export function VehicleDetailFinancing({
  vehicle,
  config,
  primaryColor,
  financingService,
}: VehicleDetailFinancingProps) {
  if (!financingService) return null;

  return (
    <ServiceModal
      service={financingService}
      serviceTitle="Simular Financiamento"
      config={config}
      preSelectedVehicle={vehicle}
    >
      <Button
        variant="outline"
        size="lg"
        className="w-full border-2 transition-all duration-300 shadow-sm hover:shadow-md"
        style={{ borderColor: `${primaryColor}40`, color: primaryColor }}
        onMouseEnter={(e) => {
          e.currentTarget.style.borderColor = primaryColor;
          e.currentTarget.style.backgroundColor = `${primaryColor}10`;
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.borderColor = `${primaryColor}40`;
          e.currentTarget.style.backgroundColor = 'transparent';
        }}
      >
        <CreditCard className="h-5 w-5 mr-2" />
        Simular financiamento
      </Button>
    </ServiceModal>
  );
}
